import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';

import { NoDataComponent } from './no-data.component';

export { NoDataComponent } from './no-data.component';

@NgModule({
  declarations: [
    NoDataComponent
  ],
  imports: [],
  exports: [
    NoDataComponent
  ],
  schemas: [ CUSTOM_ELEMENTS_SCHEMA ]
})
export class NoDataModule {}
